import * as z from "zod";

// The reset of the second factors of an external user with four eyes (ADR-201, ADR-178 §5.4): an internal user
// records the request of the owner and the call back to a known contact of its organization; a second internal user
// approves it, and only then the factors go.

const note = z.string().trim().min(1).max(1000);

/** The body of `POST /identity/users/{userId}/mfa/reset-requests`. */
export const requestMfaResetBody = z.object({
  /**
   * The contact of the user's organization Tomorrow called back, from the directory of party (`contact_person`): its
   * phone is the one on record, never a number given by whoever asked.
   */
  contactPersonId: z.uuid(),
  /** What the call established: who answered, and that the owner asked. */
  callbackNote: note,
});
export const requestMfaResetInput = requestMfaResetBody.extend({ userId: z.uuid() });
export type RequestMfaResetInput = z.input<typeof requestMfaResetInput>;

export const mfaResetRequestInput = z.object({ requestId: z.uuid() });
export type MfaResetRequestInput = z.input<typeof mfaResetRequestInput>;

/** The body of `POST /identity/mfa-reset-requests/{requestId}/reject`. */
export const rejectMfaResetBody = z.object({ reason: note });
export const rejectMfaResetInput = rejectMfaResetBody.extend({ requestId: z.uuid() });
export type RejectMfaResetInput = z.input<typeof rejectMfaResetInput>;

/** A request that waits for the second internal user, as Backstage shows it next to the factors of the user. */
export const mfaResetRequestDto = z
  .object({
    id: z.uuid(),
    requestedAt: z.iso.datetime(),
    /** Null only for a request written without a user, which identity never does. */
    requestedBy: z.object({ id: z.uuid(), name: z.string().nullable() }).nullable(),
    /** The Actor asked it: another internal user approves (ADR-201). */
    requestedByYou: z.boolean(),
    /** The contact called back, as it was at the call. */
    contact: z.object({ id: z.uuid(), name: z.string().nullable(), phone: z.string() }),
    callbackNote: z.string(),
  })
  .meta({ id: "MfaResetRequest" });
export type MfaResetRequestDto = z.infer<typeof mfaResetRequestDto>;

export const mfaResetRejectedDto = z.object({ rejected: z.literal(true) });
